import React from 'react';
import PropTypes from 'prop-types';

import { HAS_WINDOW } from '@eb/feature-detection';
import { Pagination } from '@eb/eds-pagination';

export default class SearchFooter extends React.Component {
    static propTypes = {
        currentPage: PropTypes.number.isRequired,
        totalNumResults: PropTypes.number.isRequired,
        hasEventResults: PropTypes.bool,
    };

    _onGetPage = (pageNumber) => {
        const { handleGetPage, history } = this.props;

        if (HAS_WINDOW) {
            window.scrollTo(0, 0);
        }
        // Offset by -1 because our Redux pagination assumes pages start at 0, EDS assumes pages start at 1
        handleGetPage(pageNumber - 1, history);
    };

    render() {
        const { currentPage, totalNumResults, hasEventResults } = this.props;

        if (!hasEventResults) {
            return null;
        }

        return (
            <footer className="eds-l-mar-bot-10">
                <Pagination
                    // If currentPage is 0 we want to default to 1 instead
                    pageNumber={currentPage + 1}
                    totalNumResults={totalNumResults}
                    size="minimal"
                    // eslint-disable-next-line react/jsx-handler-names
                    onSelected={this._onGetPage}
                />
            </footer>
        );
    }
}
